import type { App } from "vue";
import { Icon } from "./Icon";
import { BaseButton } from "./Button";
import { FormHelp } from "./FormHelp";

export const setupGlobCom = (app: App<Element>): void => {
  app.component("Icon", Icon);
  app.component("BaseButton", BaseButton);
  app.component("FormHelp", FormHelp);
};
